import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [
    ConfigModule.withConfig({
      routing: {
        routes: {
          orderForm: {
            paths: ['product/:code/:name/order-form'],
            paramsMapping: { productCode: 'code', productName: 'name' },
          },
        },
      },
    }),
  ],
})
export class OrderFormRoutesModule {}
